    import React from 'react';
    import './TourHero.scss';

    const TourHero = () => {
    return (
        <section className="sec-tour-hero">
        <div className="TourHero">
            <div className="box-main">
            <h1 className="tour-title">캠퍼스 투어</h1>
            <p className="tour-desc">
                GIST의 아름다운 캠퍼스와 최첨단 연구 시설을 직접 둘러보세요.
                <br />
                지온나래 홍보대사가 여러분을 안내합니다.
            </p>
            </div>
        </div>
        </section>
    );
    };

    export default TourHero;